import fetch from '../../../core/fetch';
import history from '../../../core/history';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import showToaster from '../../../helpers/showToaster';
import { updatePopularLocation } from '../../../lib/graphql';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({ restrictType: 'popularLocation', restrictValue: values?.id }));
  if (isRestrict) return;

  if (values.image == null) {
    showToaster({ messageId: 'uploadLocImage', toasterType: 'error' })
    return;
  }

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: updatePopularLocation,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  showToaster({
    messageId: data?.updatePopularLocation?.status === "success" ? 'updateLocation' : 'updateLocationError',
    toasterType: data?.updatePopularLocation?.status === "success" ? 'success' : 'error'
  })

  data?.updatePopularLocation?.status === "success" && history.push('/siteadmin/popularlocation');

}

export default submit;
